export default __webpack_public_path__ + "static/media/banner1.1dbbf1c5.jpeg";